import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { GuestService } from '@core/auth/guest.service';
import { UserService } from '@core/services/user.service';
import { of } from 'rxjs';

export const GuestGuard: CanActivateFn = (route) => {
  const userService = inject(UserService);
  const guestService = inject(GuestService);

  if (guestService.hasValidToken()) {
    initGuestUser(route.params['id'], userService, guestService);
  }
  return of(true);
};

export function initGuestUser(
  sharedId: string,
  userService: UserService,
  guestService: GuestService,
): void {
  userService.setUser(guestService.getGuestUser(sharedId));
  guestService.initGuestPermissions();
}
